import React from 'react';

type LockIconAltProps = {
  width?: number;
  height?: number;
};

export const LockIconAlt: React.FC<LockIconAltProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 20 20' fill='none'>
    <path
      d='M4.84374 8.28125H15.1562C15.1562 8.28125 16.3021 8.28125 16.3021 9.42708V17.4479C16.3021 17.4479 16.3021 18.5937 15.1562 18.5937H4.84374C4.84374 18.5937 3.69791 18.5937 3.69791 17.4479V9.42708C3.69791 9.42708 3.69791 8.28125 4.84374 8.28125Z'
      stroke='#5D666D'
      strokeWidth='1.5'
    />
    <path
      d='M5.98959 8.28125V5.41667C5.98959 4.35304 6.41212 3.33297 7.16422 2.58087C7.91632 1.82877 8.93638 1.40625 10 1.40625C11.0636 1.40625 12.0837 1.82877 12.8358 2.58087C13.5879 3.33297 14.0104 4.35304 14.0104 5.41667V8.28125'
      stroke='#5D666D'
      strokeWidth='1.5'
    />
    <path
      d='M8.28125 13.4375C8.28125 13.8933 8.46233 14.3305 8.78466 14.6528C9.10699 14.9752 9.54416 15.1562 10 15.1562C10.4558 15.1562 10.893 14.9752 11.2153 14.6528C11.5377 14.3305 11.7187 13.8933 11.7187 13.4375C11.7187 12.9817 11.5377 12.5445 11.2153 12.2222C10.893 11.8998 10.4558 11.7187 10 11.7188C9.54416 11.7187 9.10699 11.8998 8.78466 12.2222C8.46233 12.5445 8.28125 12.9817 8.28125 13.4375Z'
      stroke='#5D666D'
      strokeWidth='1.5'
    />
  </svg>
);
